import React, { Component } from 'react';
import axios from 'axios';
import { Button, Toast, ToastHeader, ToastBody } from 'reactstrap';

import { authProvider } from '../authProvider';
import { Panel, PanelType, DefaultButton, PrimaryButton, TooltipHost } from '@fluentui/react';
import { EstimateEditor } from './EstimateEditor'
import { EstimateCostingEditor } from './EstimateCostingEditor'

export class Estimate extends Component {
    static displayName = Estimate.name;

    constructor(props) {
        super(props);
        var rootUrl = window.location.protocol + '//' + window.location.host + '/';
        this.state = {
            currentCount: 0, rootUrl: rootUrl, token: '', isAuthorized: false,
            headers: {}, estimate: null, lookups: { revenues: [], industries: [], smsTypes: [] },
            showSaveToast: false, hasChanges: false,
            costingDefsShown: false,
            userRoles: [], isAdmin: false, canEdit: false, hasCostingDefs: false

        };

        this.incrementCounter = this.incrementCounter.bind(this);
        this.componentDidMount = this.componentDidMount.bind(this);
        this.get_estimates = this.get_estimates.bind(this);
        this.get_lookups = this.get_lookups.bind(this);
        this.get_new = this.get_new.bind(this);
        this.onSaveClicked = this.onSaveClicked.bind(this);
        this.onAddCompany = this.onAddCompany.bind(this);
        this.onCostingUpdate = this.onCostingUpdate.bind(this);
        this.update_estimate = this.update_estimate.bind(this);
        this.toggleSaveToast = this.toggleSaveToast.bind(this);
        this.toggleCostingDefs = this.toggleCostingDefs.bind(this);
        this.onPrintView = this.onPrintView.bind(this);
        this.updateHasDefs = this.updateHasDefs.bind(this);

    }
    componentDidMount() {
        var self = this;

        authProvider.getIdToken().then(function (result) {

            if (result.idToken && result.idToken.claims && result.idToken.claims.roles) {
                self.setState({ userRoles: result.idToken.claims.roles });
            }
            else { self.setState({ userRoles: [] }) }
            self.updatePermissions();
        });
        authProvider.getAccessToken().then(function (result) {

            var tkn = result.accessToken;

            if (tkn) {

                self.setState({ token: tkn, isAuthorized: true, headers: { 'Authorization': "Bearer " + tkn }, editedEstimate: null });
                self.get_estimates();
                self.get_lookups();
            }
            else {
                console.log("Token not acquired!")
            }
        });
    }

    incrementCounter() {
        this.setState({
            currentCount: this.state.currentCount + 1

        });
    }
    updatePermissions() {
        console.log(this.state.userRoles);
        if (this.state.userRoles.indexOf("Administrator") > -1) {
            this.setState({ isAdmin: true });
        }
        if (this.state.userRoles.indexOf("Estimate.ReadWrite") > -1) {
            this.setState({ canEdit: true });
        }
    }
    get_lookups() {
        axios.get(this.state.rootUrl + "Industry", { headers: this.state.headers }).then(res => {
            var industries = res.data;
            if (industries) {
                var lookups = this.state.lookups;
                lookups.industries = industries;
                this.setState({ lookups: lookups });
            }
        })
        axios.get(this.state.rootUrl + "RevenueRange", { headers: this.state.headers }).then(res => {
            var revenues = res.data;
            if (revenues) {
                var lookups = this.state.lookups;
                lookups.revenues = revenues;
                this.setState({ lookups: lookups });
            }
        })
        axios.get(this.state.rootUrl + "SmsTypes", { headers: this.state.headers }).then(res => {
            var smsTypes = res.data;
            if (smsTypes) {
                var lookups = this.state.lookups;
                lookups.smsTypes = smsTypes;
                this.setState({ lookups: lookups });
            }
        })
    }
    onSaveClicked(event) {
        axios.post(this.state.rootUrl + 'SmsEstimates', this.state.editedEstimate, { headers: this.state.headers }).then(res => {
            var estimate = res.data;
            if (estimate) {
                this.setState({ editedEstimate: estimate, showSaveToast: true, hasChanges: false });

            }
            else {
                // Errot
            }
        })
    }
    updateHasDefs() {
        this.setState({ hasCostingDefs: false });
        if (this.state.EditedEstimate && this.state.EditedEstimate.id > 0) {
            axios.get(this.state.rootUrl + this.state.EditedEstimate.id + "/hasCostingDefs", { headers: this.state.headers }).then(res => {
                if (res.data) {
                    this.setState({ hasCostingDefs: true });
                }
            })
        }
    }
    toggleSaveToast() {
        this.setState({ showSaveToast: !this.state.showSaveToast });
    }
    onPrintView() {
        if (this.state.editedEstimate && this.state.editedEstimate.id > 0) {
            axios.get(this.state.rootUrl + 'SmsQuoteHistory/GetPrint/' + this.state.editedEstimate.id, { headers: this.state.headers }).then(res => {
                if (res.data) {
                    window.location.href = "/printEstimate/" + res.data;
                } else if (res.data == 0) {
                    window.alert("This estimate must be saved in the current version before it can be printed.");
                }
            });
        }
    }
    onAddCompany(event) {
        const estimate = this.state.editedEstimate;
        if (estimate.childCompanies == null) {
            estimate.childCompanies = [];
        }
        estimate.childCompanies.push(this.get_new());
        this.setState({ editedEstimate: estimate });
    }
    get_estimates() {
        const { id } = this.props.match.params
        if (id) {
            axios.get(this.state.rootUrl + 'SmsEstimates/' + id, { headers: this.state.headers }).then(res => {
                var estimate = res.data;
                if (estimate) {
                    this.setState({ editedEstimate: estimate });
                    this.updateHasDefs();
                }
                else {
                    this.setState({
                        editedEstimate: this.get_new()
                    });
                }

            });
        }
        else {
            this.setState({ editedEstimate: this.get_new() });
        }
    }
    get_new() {
        return {
            "id": 0,
            "parentId": null,
            "firstName": "",
            "lastName": "",
            "email": "",
            "phoneNumber": "",
            "childCompanies": [
            ],
            "revenueId": null,
            "industryId": null,
            "companyName": "",
            "locations": 0,
            "users": 0,
            "workstations": 0,
            "servers": 0,
            "esxHosts": 0,
            "san": 0,
            "switchesRouters": 0,
            "firewalls": 0,
            "wirelessControllers": 0,
            "accessPoint": 0,
            "ipCamera": 0,
            "ipPhone": 0,
            "ups": 0,
            "domains":0,
            "backupAppliance": 0,
            "otherSnmpDevices": 0,
            "otherIcmpDevices": 0,
            "networkInfrastructure": 0,
            "printers": 0,
            "otherDevices": 0,
            "companyUnitPrice": 0,
            "companyExtPrice": 0,
            "endPointQty": 0,
            "endpointUnitPrice": 0,
            "endpointExtPrice": 0,
            "deviceQty": 0,
            "deviceUnitPrice": 0,
            "deviceExtPrice": 0,
            "locationQty": 0,
            "locationUnitPrice": 0,
            "locationExtPrice": 0,
            "domainsQty": 0,
            "domainsUnitPrice": 0,
            "domainsExtPrice":0,
            "socDeviceQty":0,
            "socDeviceUnitPrice": 0,
            "socDeviceExtPrice": 0,
            "userQty": 0,
            "userUnitPrice": 0,
            "userExtPrice": 0,
            "onboardingUnitPrice": 0,
            "onboardingExtPrice": 0,
            "initialAssessmentUnitPrice": 0,
            "initialAssessmentExtPrice": 0,
            "initialPolicyManagementUnitPrice": 0,
            "initialPolicyManagementExtPrice": 0,
            "cyberInsuranceFee": 0,
            "blockTimeQuantity": 0,
            "blockTimeUnitPrice": 0,
            "blockTimeExtPrice": 0
        };
    }
    update_estimate(original_estimate, newEstimate) {
        if (original_estimate === this.state.editedEstimate) {
            this.setState({ editedEstimate: newEstimate, hasChanges: true });
            this.updateHasDefs();
        }
        else {
            var estimate = this.state.editedEstimate;
            if (estimate.childCompanies) {
                for (var i = 0; i < estimate.childCompanies.length; i++) {
                    if (estimate.childCompanies[i] === original_estimate) {
                        estimate.childCompanies[i] = newEstimate;
                        this.setState({ editedEstimate: estimate, hasChanges: true });
                        this.updateHasDefs();
                        break;
                    }
                }
            }
        }
    }
    

    toggleCostingDefs() {
        this.setState({ costingDefsShown: !this.state.costingDefsShown });
    }
    onCostingUpdate() {
        const orig = this.state.editedEstimate;
        axios.post(this.state.rootUrl + 'SmsEstimates/CalculateEstimate', orig, { headers: this.state.headers }).then(res => {
            var estimate = res.data;
            if (estimate) {
                this.update_estimate(orig, estimate);
            }

        });
    }
    render() {
        const estimate = this.state.editedEstimate;
        const headers = this.state.headers;
        const lookups = this.state.lookups;
        var children = [];

        if (estimate) {
            if (estimate.childCompanies) {
                children = estimate.childCompanies;
            }
        }

        // Disable button if no changes.
        var saveButton = "";
        console.log("canEdit: " + this.state.canEdit);
        if (this.state.canEdit) {
            if (this.state.hasChanges)
                saveButton = <PrimaryButton style={{ verticalAlign: "top" }} className="d-print-none" onClick={this.onSaveClicked}>Save</PrimaryButton>
            else
                saveButton = <PrimaryButton style={{ verticalAlign: "top" }} className="d-print-none" size="sm" color="success" disabled={true}>Save</PrimaryButton>
        } else {
            saveButton = <PrimaryButton style={{ verticalAlign: "top" }} className="d-print-none" disabled={true}>Read-Only</PrimaryButton>
        }
        var printTooltip = "Click to view the printable version of the estimate.";
        if ((!this.state.editedEstimate)) {
            printTooltip = "There is no estimate loaded.";
        } else if (this.state.editedEstimate.id == 0 || this.state.hasChanges) {
            printTooltip = "This estimate must be saved before it can be printed.";
        }
        var subsidiaryLabel = "";
        if (children.length > 0) {
            subsidiaryLabel = <h2 className="subsidiaryLabel breakBefore">Subsidiaries</h2>
        }
        return (
            <div>
                <img className="d-none d-print-block" src="/Images/horizlogo.png" alt="Networking Technologies horizontal logo" />
                <br className="d-none d-print-block " />
                <h2>Secure Managed Services Estimate</h2>
                <div>{saveButton}
                    {this.state.isAdmin &&
                        <TooltipHost content={this.state.hasCostingDefs ? "Edit costing definitions for this estimate." : "This estimate must be saved before its costing definitions can be edited."}>
                            <DefaultButton disabled={!this.state.hasCostingDefs} onClick={this.toggleCostingDefs}>Cost Config</DefaultButton>
                        </TooltipHost>
                    }
                    <TooltipHost content={printTooltip}>
                        <DefaultButton className="d-print-none" disabled={(!this.state.editedEstimate) || this.state.editedEstimate.id == 0 || this.state.hasChanges} onClick={this.onPrintView}>Print View</DefaultButton>
                    </TooltipHost>
                </div>

                <EstimateEditor estimate={estimate} 
                headers={headers} 
                onEstimateUpdated={this.update_estimate} 
               
                lookups={lookups} />

                {subsidiaryLabel}
                {children.map((item, ind) => <EstimateEditor key={ind} estimate={item} onEstimateUpdated={this.update_estimate} headers={headers} lookups={lookups} />)}
                <div className="d-print-none" style={{ marginBottom: '5px' }}>
                    {this.state.canEdit && <PrimaryButton style={{ verticalAlign: "top" }} className="d-print-none" onClick={this.onAddCompany}>Add Subsidiaries</PrimaryButton>}
                    {saveButton}
                </div>
                <Toast isOpen={this.state.showSaveToast} className="position-absolute bottom-0 end-0">
                    <ToastHeader toggle={this.toggleSaveToast}>Estimate Saved</ToastHeader>
                    <ToastBody>The estimate has been successfully saved.</ToastBody>
                </Toast>
                {this.state.isAdmin && this.state.editedEstimate && <Panel headerText="Costing Definitions" isLightDismiss type={PanelType.customNear} customWidth="500px"
                    isOpen={this.state.costingDefsShown} onDismiss={this.toggleCostingDefs} closeButtonAriaLabel="Close">
                    <EstimateCostingEditor estimateId={this.state.editedEstimate.id} onUpdated={this.onCostingUpdate} />
                </Panel>}
            </div>
        );
    }
}
